import { FontDescription } from "./FontDescription";
import { GlyphInfo } from "./GlyphInfo";
import { ASCIITransformer } from "./ASCIITransformer";

export class FontWidthRange
{
  startIndex:number = 0;
  widths:number[] = [];
}

export class FontInfo
{
  fontName:string;
  weight:number;
  italic:boolean;
  widthRanges:FontWidthRange[];

  getWidth( word:string, fontSize:number )
  {    
    if ( word === null || word.length === 0 )
    {
      return 0;
    }

    return this.getWidthOfCharacters( Array.from( word ), fontSize );
  }

  getWidthOfCharacters( characters:string[], fontSize:number )
  {
    if ( characters === null || characters.length === 0 )
    {
      return 0;
    }

    let width = 0;

    characters.forEach( c => { width += this.getCharacterWidth( c, fontSize ); } );
    
    return width;

  }

  getCharacterWidth( character:string, fontSize:number ):number
  {
    let unicodeCodePointValue = character.codePointAt( 0 );

    let lookUpIndex = 32; // space is default

    if ( unicodeCodePointValue < 126 )
    {
      lookUpIndex = unicodeCodePointValue;
    }
    else 
    {
      let asciiCharacter = ASCIITransformer.transformCharacter( character );
      lookUpIndex = asciiCharacter.codePointAt( 0 );
    }


    return this._getCharacterWidthAtIndex( lookUpIndex ) / 1000 * fontSize;
  }

  private _getCharacterWidthAtIndex( characterIndex:number )
  {
    return this.widthRanges[ 0 ].widths[ characterIndex - 32 ];
  }

  static hashName( info:FontInfo|FontDescription )
  {
    let hash = info.fontName + "_" + info.weight;

    if ( info.italic )
    {
      hash += "_italic";
    }

    return hash;
  }
}